import { render, staticRenderFns } from "./StartLeft.vue?vue&type=template&id=5210c2c8&"
import script from "./StartLeft.vue?vue&type=script&lang=js&"
export * from "./StartLeft.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports